module.exports = __webpack_public_path__ + "img/consultation2-mini.84eceebc.png";